'use client';

import { useTranslations } from 'next-intl';
import { FOOTER_LINK_GROUPS } from './footer-link-groups';
import { Link } from './link';

export function FooterSitemap(): React.JSX.Element {
  const t = useTranslations('footer');
  return (
    <>
      {FOOTER_LINK_GROUPS.map((group) => (
        <div key={group.headingKey} data-reveal="up">
          <h3 className="text-sm/6 font-medium text-foreground/50">{t(group.headingKey)}</h3>
          <ul className="mt-5 space-y-3.5 text-sm/6">
            {group.items.map((item) => (
              <li key={item.href}>
                <Link
                  href={item.href}
                  target={item.isExternal ? '_blank' : undefined}
                  className="cm-underline font-medium text-foreground/80 data-hover:text-foreground"
                >
                  {t(item.labelKey)}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </>
  );
}
